import { Breadcrumb, Button, Card, Empty, Tabs } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { ReactComponent as TitleIcon } from "../../../../assests/images/accountBread.svg";
import { useTranslation } from "react-i18next";
import { amountFormat } from "../../../../services/common.service";
import AccountService from "../../../../services/accounts.service";
import { modeSelector } from "../../../../store/selectors/app.selector";
import { useSelector } from "react-redux";
import { ReactComponent as HomeIcon } from "../../../../assests/images/home-line.svg";

export default function DisbursementInquiry() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState("ACCOUNT_DETAILS");
  const [accountDetails, setAccountDetails] = useState({});
  const [details, setDetails] = useState({});
  const [disbursementDetails, setDisbursementDetails] = useState([]);
  const mode = useSelector(modeSelector);
  const [showGridAccount, setShowGridAccount] = useState("GRID");

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);

  useEffect(() => {
    if (location.pathname === "/accounts/loan/disbursement-inquiry") {
      setActiveKey("DISBURSEMENT_INQUIRY");
    }
    if (location.state) {
      setAccountDetails(location.state);
    }
    getLoanDisbursement(location.state);
  }, []);

  const handleTabClick = (key) => {
    setActiveKey(key);
    if (key === "ACCOUNT_DETAILS") {
      navigate("/accounts/loan/summary", { state: accountDetails });
    }
    if (key === "DETAILED_STATEMENT") {
      navigate("/accounts/loan/statement", {
        state: accountDetails,
      });
    }
    if (key === "SCHEDULE_INQUIRY") {
      navigate("/accounts/loan/schedule-inquiry", {
        state: accountDetails,
      });
    }
    if (key === "REPAYMENT") {
      navigate("/accounts/loan/repayment", {
        state: accountDetails,
      });
    }
  };

  const getLoanDisbursement = useCallback(async (values) => {
    try {
      const response = await AccountService.getLoanDisbursement({
        accountNo: values.accountNo,
        branchId: values?.branchId,
      });
      if (response.status === 200) {
        setDetails(response.data);
        setDisbursementDetails(response.data["disbursementDetails"]);
      }
    } catch (error) {}
  }, []);

  return (
    <>
      <Breadcrumb separator=">">
        {/* <Breadcrumb.Item>
          <span onClick={() => navigate("/dashboard")}>
            <HomeIcon height={14} />
          </span>
        </Breadcrumb.Item> */}
        <Breadcrumb.Item>
          <span onClick={() => navigate("/accounts")}>
            {" "}
            {t("navigation.account", {
              defaultValue: "Accounts",
            })}
          </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span>
            {t("pages.my_accounts.loans.disbursement_inquiry", {
              defaultValue: "Disbursement Inquiry",
            })}
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("pages.my_accounts.loans.disbursement_inquiry", {
                defaultValue: "Disbursement Inquiry",
              })}
            </h3>
          </div>
        </div>
      </Card>

      <Card className="account-tab-card mb-1">
        <Tabs
          defaultActiveKey="1"
          type="line"
          onChange={setActiveKey}
          activeKey={activeKey}
          onTabClick={handleTabClick}
        >
          <Tabs.TabPane
            tab={t("pages.my_accounts.loans.loan_and_finance_details", {
              defaultValue: "Investment and Finance Details",
            })}
            key="ACCOUNT_DETAILS"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("buttons.view_stmt_btn", {
              defaultValue: "View Statement",
            })}
            key="DETAILED_STATEMENT"
          ></Tabs.TabPane>
          {["I", "AA"].indexOf(mode) > -1 && (
            <Tabs.TabPane
              tab={t("pages.my_accounts.loans.repayment", {
                defaultValue: "Repayment",
              })}
              key="REPAYMENT"
            ></Tabs.TabPane>
          )}
          <Tabs.TabPane
            tab={t("pages.my_accounts.loans.disbursement_inquiry", {
              defaultValue: "Disbursement Inquiry",
            })}
            key="DISBURSEMENT_INQUIRY"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("pages.my_accounts.loans.schedule_inquiry", {
              defaultValue: "Schedule Inquiry",
            })}
            key="SCHEDULE_INQUIRY"
          ></Tabs.TabPane>
        </Tabs>
      </Card>
      <Card className="application-card">
        <div className="account-details">
          <div className="row">
            <div className="col-12 col-sm-6 col-md-6 col-lg-3">
              <label>
                {" "}
                {t("pages.accounts.accounts_common.account_no", {
                  defaultValue: "Account Number",
                })}
              </label>
              <span>{details?.accountNo || "-"}</span>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-3">
              <label>
                {t("pages.my_accounts.loans.sanctioned_amount", {
                  defaultValue: "Sanctioned Amount",
                })}
              </label>
              <span>{amountFormat(details?.sanctionedAmount || "0")}</span>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-3 ">
              <label>
                {t("pages.my_accounts.loans.disbursed_amount", {
                  defaultValue: "Disbursed Amount",
                })}
              </label>
              <span>{amountFormat(details?.disbursedAmount || "0")}</span>
            </div>
          </div>
        </div>
      </Card>
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        {showGridAccount === "GRID" &&
          (disbursementDetails.length === 0 ? (
            <Empty description="No data found" className="mt-2"/>
          ) : (
            <div className="ft-table mt-2">
              <table className="table">
                <thead style={{ backgroundColor: "#F1F1F1" }}>
                  <tr>
                    <th>
                      {t("pages.my_accounts.loans.s_no", {
                        defaultValue: "S.No",
                      })}
                    </th>
                    <th>
                      {t("pages.sendMoney.common_sendMoney.date", {
                        defaultValue: "Date",
                      })}
                    </th>
                    <th>{t("common.amount", { defaultValue: "Amount" })}</th>
                  </tr>
                </thead>
                <tbody>
                  {disbursementDetails.map((option, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{option?.disbursementDate || "-"}</td>
                      <td>{amountFormat(option?.amount || "0")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        {showGridAccount === "LIST" &&
          (disbursementDetails.length === 0 ? (
            <Empty description="No data found" />
          ) : (
            disbursementDetails.map((option, idx) => (
              <div key={idx}>
                <div className="account-row-data list-row mb-2 mt-2">
                  <div>
                    <div>{option?.disbursementDate || "-"}</div>
                  </div>
                  <div align="right">{amountFormat(option?.amount || "0")}</div>
                </div>
              </div>
            ))
          ))}
      </div>
    </>
  );
}
